/// <reference path="../../app.d.ts"/>
/// <reference path="../../../../typings/jquery.d.ts"/>
import { AppUtils } from '../../../../../shared/utils/index';
import { AppFormModel } from '../models/AppFormModel';
import { BasicViewService } from "../../../../../shared/services/BasicViewService";
import { PersonalDataModel } from '../../../../../shared/models/view/PersonalData';
import { AdresseModel } from '../../../../../shared/models/view/Adresse';
import { AdvertisingConsentModel } from '../../../../../shared/models/view/AdvertisingConsent';
import { PrivacyAcceptanceApi } from '../../../../../shared/models/generated/PersonPrivacyAcceptanceApi';
import { BasicApplicationUrlBuilder } from '../../../../../shared/services/BasicApplicationUrlBuilder';


export class AppViewService extends BasicViewService<AdvertisngConsentAppDefinition> {
	protected readonly urlBuilder: BasicApplicationUrlBuilder<AdvertisngConsentAppDefinition>;

	private readonly emailPhoneAndPersonalizationSelector = '.js-email, .js-phone, .js-personalization';
	private readonly einwilligungSelector = ".js-einwilligung";
	private readonly autocompletePendingFlag = 'autocomplete-pending';

	constructor(parent: StepController, options: BasicAppOptions<AdvertisngConsentAppDefinition>, loader: BasicLoader<AdvertisngConsentAppDefinition>) {
		super(parent, options, loader);
		this.urlBuilder = new BasicApplicationUrlBuilder(options);
		this.formId = 'advertisingconsentapplication';
	}

	public addListeners(handler: StandardViewEvents): void {
		const $form = this.getForm();

		// init form listener
		$form.find('input, select, textarea').on('change', handler.viewChangeListener.bind(handler));
		$form.on('submit', handler.submitListener.bind(handler));
		this.$ctx.find('.js-submit-form').on('click', handler.submitListener.bind(handler));
		$form.find(this.emailPhoneAndPersonalizationSelector).on('change', this.toggleEinwilligung.bind(this));
		$form.find(this.einwilligungSelector).on('change', this.clearOptions.bind(this));
		$form.find('.js-phone').on('change', this.showPhoneHint.bind(this));
		this.installAutocomplete($form);

		// init all form elements from ew72
		S.Utils.FormAside.init();
		AppUtils.View.initFormElements();
	}

	public getFormModelFromView(formModel?: AppFormModel): AppFormModel {
		const formData = this.getFormData();
		if (!formModel) {
			formModel = new AppFormModel();
		}

		formModel.PersonalData = this.getPersonalModel(formData);
		return formModel;
	}

	public toggleErrorText(show: boolean): void {
		this.$ctx.find('.js-error').toggleClass('h-hidden', show);
	}

	public toggleMainForm(show: boolean): void {
		this.$ctx.find('.js-main-form').toggleClass('h-hidden', show);
	}

	public getAdvertisingConsentModel(): AdvertisingConsentModel {
		const advertisingConsentModel = new AdvertisingConsentModel();
		const formData = this.getFormData();
		advertisingConsentModel.Einwilligung = Number(formData.Datenverwendung) || PrivacyAcceptanceApi.Unknown;
		advertisingConsentModel.Email = Number(formData.DatenverwendungEmailZustimmung) || PrivacyAcceptanceApi.Unknown;
		advertisingConsentModel.Telefon = Number(formData.DatenverwendungTelefonZustimmung) || PrivacyAcceptanceApi.Unknown;
		advertisingConsentModel.Telefon2 = Number(formData.DatenverwendungTelefon2Zustimmung) || PrivacyAcceptanceApi.Unknown;
		advertisingConsentModel.HerkunftsKz = this.CheckHkzFromUrl();
		advertisingConsentModel.Personalisierung = formData['Personalisierung'] ? true : false;

		return advertisingConsentModel;
	}

	public CheckHkzFromUrl(): string {
		const hkzFromUrl = AppUtils.Url.getUrlParameter("hkz", window.location.search);
		return hkzFromUrl && this.options.app.allglobalherkunftkennzeichen.includes(hkzFromUrl) ? hkzFromUrl : this.options.app.originindicator;
	}
	public showErrorLayer(): void {
		$.magnificPopup.open({
			modal: false,
			mainClass: 'l-lightbox',
			items: {
				src: '#popup_lightbox',
				type: 'inline'
			}
		});
	}

	public setConfigAutocompleteAddress(): void {
		const $autocomplete = this.getForm().find('input.js-autocomplete-address');
		const searchUrl = this.urlBuilder.fullApimUrl(this.options.app.apiautocompleteaddress);
		$autocomplete.attr('data-subscription-key', T.Utils.Application.apimSubscriptionKey);
		$autocomplete.attr('data-searchurl', searchUrl);
	}

	private installAutocomplete(form: JQuery): void {
		const $autocomplete = form.find('[data-t-decorator="autocomplete"]');
		if ($autocomplete) {
			this.$ctx.on('automcompleteSelect', this.handleAddressAutocompleteSelection.bind(this, true));
			$autocomplete.on('keypress', (e) => {
				if (e.key === 'Enter' && $autocomplete.data(this.autocompletePendingFlag)) {
					$autocomplete.data(this.autocompletePendingFlag, null);
				}
			});
			$autocomplete.trigger('keypress');
		}
	}

	private showPhoneHint(): void {
		const $page = this.$ctx.find(`#${this.formId}`);
		$page.find(".js-phone-hint").toggleClass('js-focus', $page.find(".js-phone").is(":checked"));
	}

	private getPersonalModel(formData: { [key: string]: any }): PersonalDataModel {
		const personalDataModel = new PersonalDataModel();
		personalDataModel.Mitgliedsnummer = formData.Mitgliedsnummer;
		personalDataModel.Vorname = formData.Vorname;
		personalDataModel.Nachname = formData.Nachname;
		personalDataModel.TelefonNummer = formData.TelefonNummer;
		personalDataModel.TelefonGeschaeftlichNummer = formData.TelefonGeschaeftlichNummer;
		personalDataModel.Email = formData.Email;
		personalDataModel.Adresse = new AdresseModel();
		personalDataModel.Adresse.StrasseHausnummer = formData.StrasseHausnummer;
		personalDataModel.Adresse.Postleitzahl = formData.Postleitzahl;
		personalDataModel.Adresse.Ort = formData.Ort;
		return personalDataModel;
	}

	private toggleEinwilligung(): void {
		const $form = this.getHtml();
		if (!$form.find(this.emailPhoneAndPersonalizationSelector).is(":checked")) {
			$form.find(this.einwilligungSelector).trigger("click");
		}
	}

	private getHtml(): JQuery {
		return this.$ctx.find(`#${this.formId}`);
	}

	private clearOptions(): void {
		const $page = this.getForm();
		const einw = $page.find(this.einwilligungSelector);
		if (!einw.is("checked")) {
			this.showPhoneHint();
			this.$ctx.find(this.emailPhoneAndPersonalizationSelector).prop("checked", false);
		}
	}
}